import React from "react";

import { IconCopyOutlined } from "~/components/icon";
import { cx } from "~/tools/class-variance";
import { copyToClipboard } from "~/tools/copy-to-clipboard";

import { DONT_AUTO_DISMISS, notification } from "../notification/Notification";
import { Tooltip } from "../tooltip/Tooltip";

export interface CopyToClipboardProps {
	className?: string;
	children?: React.ReactNode;
}

/**
 * The component copies the text content of its children HTML nodes to the clipboard.
 */
export class CopyToClipboard extends React.PureComponent<CopyToClipboardProps> {
	private readonly contentRef: React.RefObject<HTMLDivElement> = React.createRef();

	private readonly onCopyToClipboard = () => {
		if (!this.contentRef.current) {
			return;
		}

		const [failure, success] = copyToClipboard(this.contentRef.current.innerText);

		if (failure == null) {
			notification.success({ message: success });
		} else {
			notification.error({
				message: failure,
				duration: DONT_AUTO_DISMISS,
			});
		}
	};

	render() {
		return (
			<div
				className={cx(
					"group/copy-to-clipboard",
					"relative",
					"[&_pre]:mb-0 [&_pre]:rounded-sm [&_pre]:border [&_pre]:border-gray-400 [&_pre]:bg-gray-200 [&_pre]:px-3 [&_pre]:py-[7px] [&_pre]:text-gray-800 [&_pre]:leading-[22px]",
					this.props.className,
				)}
			>
				<div className="copyToClipboard__value" ref={this.contentRef}>
					{this.props.children}
				</div>

				<Tooltip placement="top" title="Copy to clipboard">
					<IconCopyOutlined
						className="copyToClipboard__action absolute -right-1.5 -bottom-1.5 cursor-pointer rounded-full border border-gray-400 bg-white p-[7px] text-[20px] text-gray-900 opacity-0 transition-opacity hover:text-primary-600 group-hover/copy-to-clipboard:opacity-100"
						onClick={this.onCopyToClipboard}
					/>
				</Tooltip>
			</div>
		);
	}
}
